import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { GlobalFieldsResponse } from '../types.tsx';

export const getGlobalFields = (): Promise<GlobalFieldsResponse> =>
	fetchJson<GlobalFieldsResponse>('/rest/polaris/global-fields');
